(function () {
  const sections = document.querySelectorAll(".ingredients-list--mobile");
  if (!sections.length) return;

  let ticking = false;

  function initSection(section) {
    const rule = section.querySelector(".ingredients-list__rule");
    const description = section.querySelector(".ingredients-list__description");
    const items = [...section.querySelectorAll(".ingredients-list__item")];
    if (!rule || !description || items.length === 0) return null;

    let activeItem = items[0];

    function update(midY) {
      const sectionRect = section.getBoundingClientRect();
      if (sectionRect.bottom < 0 || sectionRect.top > window.innerHeight) return;

      let closest = null;
      let closestRect = null;
      let closestDist = Infinity;

      for (const item of items) {
        const rect = item.getBoundingClientRect();
        const dist = Math.abs(rect.top + rect.height / 2 - midY);

        if (dist > closestDist) break;

        closestDist = dist;
        closest = item;
        closestRect = rect;
      }

      if (closest && closest !== activeItem) {
        activeItem?.classList.remove("active");
        activeItem?.removeAttribute("aria-current");
        closest.classList.add("active");
        closest.setAttribute("aria-current", "true");
        activeItem = closest;

        description.textContent = closest.dataset.description;

        const offset = closestRect.top - sectionRect.top;
        rule.style.transform = `translateY(${offset}px)`;
      }
    }

    return update;
  }

  const updates = [];
  for (const section of sections) {
    const update = initSection(section);
    if (update) updates.push(update);
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          const midY = window.innerHeight / 2;
          updates.forEach((update) => update(midY));
          ticking = false;
        });
      }
    },
    { passive: true },
  );

  const midY = window.innerHeight / 2;
  updates.forEach((update) => update(midY));
})();
